import { NAME } from './constants';

export const ENABLE = `${NAME}/enable`;
export const DISABLE = `${NAME}/disable`;
